import React from "react";
import { styled } from '@mui/material/styles';
import { Box, Button, useTheme, Typography, useMediaQuery } from "@mui/material/";

import t__ from "../../util/lang/util";
import intro from "../../util/lang/intro";
import newYorkPhoto from "./images/Left_NewYorkCity.jpg";
import LaPhoto from "./images/Right_LosAngeles.jpg";

const PREFIX = 'IntroCity';

const classes = {
  cityHeadline: `${PREFIX}-cityHeadline`,
  cityText: `${PREFIX}-cityText`,
  cityPhoto: `${PREFIX}-cityPhoto`,
  blackBtn: `${PREFIX}-blackBtn`
};

const StyledBox = styled(Box)((
  {
    theme
  }
) => ({
  [`& .${classes.cityHeadline}`]: {
    maxWidth: 325,
    marginBottom: "16px",
    fontSize: "24px",
    lineHeight: "32px",
    fontWeight: "bold",
    [theme.breakpoints.up("md")]: {
      fontSize: "28px",
      lineHeight: "36px",
    },
  },

  [`& .${classes.cityText}`]: {
    maxWidth: "310px",
    marginBottom: "24px",
  },

  [`& .${classes.cityPhoto}`]: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "280px",
    [theme.breakpoints.up("md")]: {
      minHeight: "316px",
    },
  },

  [`& .${classes.blackBtn}`]: {
    backgroundColor: "#231f20",
    color: `${theme.palette.common.white} !important`,
    borderRadius: "20px",
    fontSize: "14px",
    fontWeight: "bold",
    padding: "10px 20px",
    transition: "all .4s",
    "&:hover, &:focus": {
      backgroundColor: `${theme.palette.common.white}`,
      color: "#000 !important",
    },
  }
}));

const IntroCity = ({ bg, city }) => {
  const theme = useTheme();

  const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.up("md"));

  return (
    <StyledBox
      display="flex"
      overflow="hidden"
      width="100%"
      flexDirection={isMediumScreen ? "row" : "column"}
    >
      <Box
        width={{ md: 1 / 2 }}
        className={classes.cityPhoto}
        order={city === "NY" || !isMediumScreen ? 1 : 2}
        style={{
          backgroundImage: `url(${city === "NY" ? newYorkPhoto : LaPhoto})`,
        }}
      ></Box>
      <Box
        width={{ md: 1 / 2 }}
        bgcolor={bg}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDirection="column"
        px={5}
        py={10}
        minHeight={isMediumScreen ? "316px" : "280px"}
        order={city === "NY" ? 2 : 1}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
        >
          <Typography
            component="h2"
            className={classes.cityHeadline}
            align="center"
          >
            {t__(theme.lang, intro, city)}
          </Typography>
          <Typography
            variant="h4"
            component="p"
            align="center"
            className={classes.cityText}
          >
            {city === "NY"
              ? t__(theme.lang, intro, "popularRestaurants")
              : t__(theme.lang, intro, "westCoast")}
          </Typography>
          <Button
            href={`/unionpay/guides/${
              city === "NY" ? "newyork" : "losangeles"
            }`}
            className={classes.blackBtn}
          >
            {t__(theme.lang, intro, "exploreNow")}
          </Button>
        </Box>
      </Box>
    </StyledBox>
  );
};

export default IntroCity;
